import frLocale from 'date-fns/locale/fr';

import moment from 'moment';
import { parse } from 'date-fns';

// ----------------------------------------------------------------------

export function getDateFnsLocale(locale) {
  return locale === 'fr' ? frLocale : null;
}

/**
 * Formats a date object to string (if no format is defined, ISO format will be applied).
 * @param date
 * @param format
 * @returns {string}
 */
export function formatDate(date, format) {
  if (date) {
    if (format) {
      return moment(date).format(format);
    }
    return moment(date).toISOString();
  }
  return '';
}

/**
 * Parse a string to a date object (if no format is defined, yyyyMMdd will be used).
 * @param dateStr
 * @param format
 * @returns {Date|null}
 */
export function parseDate(dateStr, format) {
  return dateStr ? parse(dateStr, format ?? 'yyyyMMdd', new Date()) : null;
}

/**
 * Checks the input value and converts it to a Date object if it is a string.
 *
 * @param {Date|string|null} value - The date value to be checked and formatted.
 * @returns {Date|null} - The formatted date as a Date object or null if the input is null.
 */
export function checkAndFormatFormDate(value) {
  if (value == null) return value;
  if (typeof value === 'string') return new Date(value);
  return value;
}

/**
 * Gets the end of the day time (in milliseconds) for the given date.
 *
 * @param {Date} date - The date for which to get the end of day time.
 * @returns {number} - The end of day time in milliseconds.
 */
export function getEndOfDayTime(date) {
  const endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
  return endOfDay.getTime();
}
